import gql from 'graphql-tag'

export const GET_DOWNLOAD_URL = gql`
  query DownloadUrl($id: UUID!) {
    downloadUrl(id: $id)
  }
`



// WEBPACK FOOTER //
// ./src/oneGraphQueries/DownloadUrl.ts